import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaPlus, FaTrash, FaEdit, FaSave, FaTimes, FaImage } from "react-icons/fa";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

export default function AdminBlog({ lang, admin_id }) {
  const [posts, setPosts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({
    id: null, title_ar: '', title_en: '', content_ar: '', content_en: '', seo_description: '', seo_keywords: ''
  });
  const [imageFile, setImageFile] = useState(null);

  const fetchPosts = async () => {
    try {
      const url = window.location.hostname === 'localhost' ? 'http://localhost/api/blog.php' : '/api/blog.php';
      const res = await axios.get(url);
      if (res.data.status === 'success') setPosts(res.data.posts);
    } catch (err) { console.error(err); }
  };

  useEffect(() => { fetchPosts(); }, []);

  const openAdd = () => {
    setEditMode(false);
    setFormData({ id: null, title_ar: '', title_en: '', content_ar: '', content_en: '', seo_description: '', seo_keywords: '' });
    setImageFile(null);
    setShowModal(true);
  };

  const openEdit = async (postSummary) => {
    try {
      const url = window.location.hostname === 'localhost' ? `http://localhost/api/blog.php?id=${postSummary.id}` : `/api/blog.php?id=${postSummary.id}`;
      const res = await axios.get(url);
      if (res.data.status === 'success') {
        setFormData({ ...res.data.post });
        setEditMode(true);
        setImageFile(null);
        setShowModal(true);
      }
    } catch (err) { alert("حدث خطأ في تحميل المقال"); }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const url = window.location.hostname === 'localhost' ? 'http://localhost/api/blog.php' : '/api/blog.php';
      const submitData = new FormData();
      submitData.append('admin_id', admin_id);
      Object.keys(formData).forEach(key => {
        if(formData[key] !== null) submitData.append(key, formData[key]);
      });
      if (editMode) submitData.append('post_id', formData.id);
      if (imageFile) submitData.append('image', imageFile);
      
      const res = await axios.post(url, submitData, { headers: { 'Content-Type': 'multipart/form-data' } });
      if (res.data.status === 'success') {
        alert("تم الحفظ بنجاح");
        setShowModal(false);
        fetchPosts();
      } else { alert(res.data.message); }
    } catch (err) { alert("حدث خطأ"); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("هل أنت متأكد من الحذف؟")) return;
    try {
      const url = window.location.hostname === 'localhost' ? 'http://localhost/api/blog.php' : '/api/blog.php';
      const submitData = new FormData();
      submitData.append('admin_id', admin_id);
      submitData.append('action', 'delete');
      submitData.append('post_id', id);
      await axios.post(url, submitData);
      fetchPosts();
    } catch (err) { alert("حدث خطأ"); }
  };

  return (
    <div className="table-container">
      <div className="section-header">
        <h4>📝 إدارة المدونة والمقالات</h4>
        <button className="btn-primary" onClick={openAdd}><FaPlus /> إضافة مقال</button>
      </div>
      
      <div className="table-responsive">
        <table className="data-table">
          <thead>
            <tr>
              <th>صورة</th>
              <th>العنوان</th>
              <th>تاريخ النشر</th>
              <th>إجراءات</th>
            </tr>
          </thead>
          <tbody>
            {posts.map(post => (
              <tr key={post.id}>
                <td>{post.image_url ? <img src={post.image_url} alt="Cover" style={{width:'50px', height:'50px', objectFit:'cover', borderRadius:'8px'}} /> : <FaImage size={24} color="#ccc" />}</td>
                <td>{post.title_ar}</td>
                <td>{new Date(post.created_at).toLocaleDateString()}</td>
                <td>
                  <button className="icon-btn" onClick={() => openEdit(post)} style={{ color: '#0E74AB', marginRight: '10px' }}><FaEdit /></button>
                  <button className="icon-btn" onClick={() => handleDelete(post.id)} style={{ color: '#F44336' }}><FaTrash /></button>
                </td>
              </tr>
            ))}
            {posts.length === 0 && <tr><td colSpan="4">لا توجد مقالات.</td></tr>}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-container" style={{maxWidth: '800px', width: '95%'}}>
            <button className="modal-close" onClick={() => setShowModal(false)}><FaTimes /></button>
            <h3>{editMode ? "تعديل مقال" : "إضافة مقال جديد"}</h3>
            <form onSubmit={handleSave} style={{display: 'flex', flexDirection: 'column', gap: '15px', marginTop: '15px'}}>
              <input type="text" placeholder="عنوان المقال (عربي)" value={formData.title_ar} onChange={e => setFormData({...formData, title_ar: e.target.value})} required className="modal-input" />
              <input type="text" placeholder="عنوان المقال (إنجليزي)" value={formData.title_en} onChange={e => setFormData({...formData, title_en: e.target.value})} required className="modal-input" />
              
              <div>
                <label>محتوى المقال (عربي)</label>
                <ReactQuill theme="snow" value={formData.content_ar} onChange={val => setFormData({...formData, content_ar: val})} style={{background: '#fff', color: '#000', marginBottom: '10px'}} />
              </div>

              <div>
                <label>محتوى المقال (إنجليزي)</label>
                <ReactQuill theme="snow" value={formData.content_en} onChange={val => setFormData({...formData, content_en: val})} style={{background: '#fff', color: '#000'}} />
              </div>

              <input type="text" placeholder="SEO Description (وصف لمحركات البحث)" value={formData.seo_description} onChange={e => setFormData({...formData, seo_description: e.target.value})} className="modal-input" />
              <input type="text" placeholder="SEO Keywords (كلمات مفتاحية مفصولة بفاصلة)" value={formData.seo_keywords} onChange={e => setFormData({...formData, seo_keywords: e.target.value})} className="modal-input" />
              
              <label className="btn-outline" style={{width: 'fit-content'}}>
                <FaImage /> اختر صورة الغلاف الحد الأقصى 2MB
                <input type="file" style={{display: 'none'}} accept="image/*" onChange={e => setImageFile(e.target.files[0])} />
              </label>
              {imageFile && <span>تم اختيار: {imageFile.name}</span>}

              <button type="submit" className="btn-primary" style={{marginTop: '10px'}}><FaSave /> حفظ ونشر</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
